import { axiosBasic } from "../config/axios-common";

const postFinishForm = async (professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/request/finishForm?professionalId=${encodeURIComponent(professionalId)}`, {}, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};


const exportedObject = {
    postFinishForm,

};


export default exportedObject